// window.location is unforgeable, so specs mock this module instead of the browser API.
export function replaceLocation(url: string): void {
  window.location.replace(url)
}

export function assignLocation(url: string): void {
  window.location.assign(url)
}
